export enum DeviceType {
    DESKTOP = "DESKTOP",
    TABLET = "TABLET",
    MOBILE = "MOBILE"
}

export enum ButtonIconType {
    EDIT = "pi-pencil",
    DELETE = "pi-trash",
    BACK = "pi-angle-double-left",
    SORT = "pi-sort-alt",
    FILTER = "pi-filter",
    CLOSE = "pi-times",
    SEARCH = 'pi-search',
    CLOSE_DIALOG = 'pi-times-circle',
    PLUS = 'pi-plus'
}

export enum LabelType {
    // mặc định
    DEFAULT = 'label-default',
    // type hình ngôi sao
    STAR = 'label-star',
    // type hình tròn
    CIRCLE = 'label-circle',
    // type hình vuông
    SQUARE = 'label-square',
    // hình chữ nhật
    RECTANGLE = 'label-rectangle',
    // hình giọt nước
    WATERDROPS = 'label-water-drops',
    // hình thoi
    RHOMBUS = 'label-rhombus'
}

export enum LabelStyle {
    // text nằm bên dưới icon
    TEXT_IS_BELLOW_ICON = 1,
    // text dược căn giữa icon
    TEXT_IS_CENTERRED_ICON = 2,
    // text có border
    TEXT_WITH_BORDER = 3
}

export enum DataType {
    TEXT = 0,
    NUMBER = 1,
    DATETIME = 2,
    PROGRESS = 3,
    STATUS = 4,
    // dạng common user
    USER = 5,
    // dạng label
    LABEL = 6,
    CHECKBOX = 7,
    COMBOBOX = 8,
    IMG = 9,
    // dạng label chữ chạy
    TEXT_RUN = 10,
    ACTIVITY = 11,
    VITAL = 12,
    LABEL_MEAL = 13
}

export enum FieldActivityType {
    NONE = -1,
    // Thuốc
    MEDICINE = 0,
    // tiểu tiện 
    URINATION = 1,
    // đại tiện
    DEFECATION = 2,
    //type khác
    GUIDANCE = 3,
    MEDICINENYUSHO = 4,
    NO_EXCRETION = 5,
    PLUS = 6,
    CHECK = 7,
    ELAPSED_TIME = 9
}

export enum FieldActivityIcon {
    // Thuốc
    MEDICINE = 'medicine-icon.svg',
    // tiểu tiện 
    URINATION = 'urination-icon.svg',
    // đại tiện
    DEFECATION = 'defecation-icon.svg',
    //type khác
    GUIDANCE = 'guidance-icon.svg',
    // Thuốc 
    MEDICINENYUSHO = 'medicine-nyusho-icon.svg',
    MEDICINENYUSHOW = 'medicine-nyusho-icon-white.svg',
    CHECK = 'check-icon.svg',
    PLUS = 'plus-icon.svg',
    SQUARE = 'square-icon.svg',
    WARNING = 'suquare-icon.svg',
    NO_EXCRETION = 'diamond-icon.svg',
    CIRCLE = 'circle-icon.svg',
}

export enum InputType {
    text, // input type text
    number, // input type number
    tel, // input type tel
    email, // input type email
    password // input type password
}

export enum SortKeyConditionOperator {
    BeginsWith = "BEGINS_WITH",
    Between = "BETWEEN",
    GreaterThanOrEqual = ">=",
    LessThanOrEqual = "<=",
    GreaterThan = ">",
    LessThan = "<"
}

export enum LeaveType {
    leave = '休',
    Wait = '待ち',
    Cancel = '中止',
    Wipe = '清拭'
}

export enum SortType {
    time_grouping_flg = 0,
    hidden_overtime_flg = 1,
    hidden_leave_user = 2
}

export enum CheckSheetDisplayOrder {
    Name = 'name',
    StartTime = 'startTime',
    EndTime = 'endTime'
}

export enum SearchType {
    input,
    combo,
    insert
}

export enum TitleType {
    record = '記録',
    schedule = '予定',
    report = '帳票',
}
